module.exports = __webpack_public_path__ + "img/icon_3_21.8cbc1ff7.png";